import { render } from "./Contact.vue?vue&type=template&id=597a8573&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=597a8573&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597a8573"]])

export default __exports__